import React from "react";
import FadeIn from "./FadeIn";

const SectionHeader = ({ eyebrow, title, subtitle, align = "center", light = false }) => {
  const alignClass =
    align === "left" ? "text-left" : align === "right" ? "text-right" : "text-center";

  return (
    <FadeIn className={`mb-10 md:mb-14 ${alignClass}`}>
      {eyebrow && (
        <div className={`mb-3 ${align === "center" ? "flex justify-center" : ""}`}>
          <span
            className={`inline-flex items-center gap-2 font-accent text-xs font-bold tracking-widest uppercase ${
              light ? "text-ku-lavender" : "text-ku-violet"
            }`}
          >
            <span className={`w-1 h-1 rounded-full ${light ? "bg-ku-gold" : "bg-ku-gold"}`} />
            {eyebrow}
          </span>
        </div>
      )}
      {title && (
        <h2
          className={`ku-heading-lg mb-4 ${light ? "text-white" : "text-ku-royal"}`}
        >
          {title}
        </h2>
      )}
      {subtitle && (
        <p
          className={`font-body text-lg md:text-xl max-w-3xl leading-relaxed ${
            align === "center" ? "mx-auto" : ""
          } ${light ? "text-white/85" : "text-gray-600"}`}
        >
          {subtitle}
        </p>
      )}
    </FadeIn>
  );
};

export default SectionHeader;
